module.exports = __webpack_public_path__ + "img/icon-ppt.ad63dcea.png";